import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X } from "lucide-react";

const LINKS = [

  { to: "/", label: "Accueil" },
  { to: "/services", label: "Services et Séances" },
  { to: "/portfolio", label: "Portfolio" },
  { to: "/creations", label: "Créations" },
  { to: "/a-propos", label: "À Propos" },
  { to: "/tarifs", label: "Tarifs et Séances" },
  { to: "/studio", label: "Studio" },
  { to: "/contact", label: "Contact" },
];
export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-[#0A0A0C]/85 backdrop-blur-xl border-b border-[#D4AF37]/15" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between h-20">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 group">
          <img src="/images/logo-passion.png" alt="Passion Photographie"
               className="h-12 w-12 object-contain transition-transform duration-500 group-hover:scale-105"
               style={{ filter: "drop-shadow(0 0 12px rgba(212,175,55,0.35))" }} />
          <span className="flex flex-col">
            <span className="font-mono text-[10px] sm:text-[11px] uppercase tracking-[0.3em] text-[#D4AF37]">
              Passion Photographie
            </span>
            <span className="font-script text-lg sm:text-xl text-[#F8F9FA] leading-tight group-hover:text-[#F3E5AB] transition-colors duration-300">
              Créer. Capturer. Raconter.
            </span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8" data-testid="nav-desktop-menu">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={({ isActive }) =>
                `text-[11px] uppercase tracking-[0.22em] transition-colors duration-300 ${
                  isActive ? "text-[#D4AF37]" : "text-slate-300 hover:text-[#F3E5AB]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          
          <a
            href="https://danphotographemariage.gallery.aftershoot.com/collection/toute-mes-collections-shooting-photos"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[11px] uppercase tracking-[0.22em] transition-colors duration-300 text-slate-300 hover:text-[#F3E5AB]"
          >
            Galeries photo
          </a>

        </nav>

        <button
          data-testid="nav-hamburger-button"
          onClick={() => setOpen(!open)}
          className="lg:hidden text-[#D4AF37] p-2"
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            data-testid="nav-mobile-menu"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            className="lg:hidden overflow-hidden bg-[#0A0A0C]/95 backdrop-blur-xl border-b border-[#D4AF37]/20"
          >
            <div className="px-6 py-8 flex flex-col gap-6">
              {LINKS.map((l, i) => (
                <motion.div
                  key={l.to}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: i * 0.06 }}
                >
                  <NavLink
                    to={l.to}
                    data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                    className={({ isActive }) =>
                      `font-serif text-2xl ${isActive ? "text-[#D4AF37]" : "text-slate-200"}`
                    }
                  >
                    {l.label}
                  </NavLink>
                </motion.div>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}
